import { ReactNode } from "react";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IToastCommonOption {
  customToastId?: string;
  removeTime?: number;
  isAutoRemove?: boolean;
  icon?: {
    name: string;
    size?: number;
  };
  position?: ["left" | "center" | "right", "top" | "center" | "bottom"];
  bottomPosition?: number;
  textAlign?: "left" | "center" | "right";
  onClick?: () => void;
}

export interface IToastOption extends IToastCommonOption {
  emoji?: string;
}
export interface IToast extends IToastOption {
  id: number | string;
  message: string | ReactNode;
}

export interface ISnackbarOption extends IToastCommonOption {
  type?: "default" | "error";
  isShowClose?: boolean;
  buttonText?: string;
}
export interface ISnackbar extends ISnackbarOption {
  id: number | string;
  message: string | ReactNode;
}

interface IToastState {
  lastToastId: number;
  lastSnackbarId: number;
  toasts: IToast[];
  snackbars: ISnackbar[];
}

const initialState: IToastState = {
  lastToastId: 0,
  lastSnackbarId: 0,
  toasts: [],
  snackbars: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast(state, action) {
      state.lastToastId = action.payload.id;
      state.toasts.push({ ...action.payload });
    },
    removeToast(state, action) {
      state.toasts = state.toasts.filter((toast: IToast) => toast.id !== action.payload);
    },
    clearToasts(state) {
      state.toasts = [];
    },
    showSnackbar(state, action) {
      state.lastSnackbarId = action.payload.id;
      state.snackbars.push({ ...action.payload });
    },
    removeSnackbar(state, action) {
      state.snackbars = state.snackbars.filter(
        (snackbar: ISnackbar) => snackbar.id !== action.payload,
      );
    },
    clearSnackbars(state) {
      state.snackbars = [];
    },
  },
});

export const { showToast, removeToast, clearToasts, showSnackbar, removeSnackbar, clearSnackbars } =
  toastSlice.actions;

export const toastData = (state: RootState) => state.toast;
export default toastSlice.reducer;
